import Logger from '@hello10/logger';

const logger = new Logger('jump');

export default logger;
